import { getUserInfo, logout } from "@/api/user";
import { GetBranchNames } from "@/api/branch";

import {} from "@/utils/auth";
import {
  hasAdminPermission,
  hasHesabdarPermission,
  hasModirPermission,
  hasModirAdminPermission,
  getToken,
  getFullName,
  getNumSystem,
  setToken,
  setSlider,
  removeToken,
  getImage,
  getBranches,
  getPermissions,
  getCurrentBranch,
  hasUserPermission,
  hasAshpazPermission,
  hasReporterPermission,
  getCurrentRole,
  getAutoDelivery,
  setBranches,
} from "../../utils/auth";
export default {
  state: {
    ImageUrl: getImage(),

    Num_System: getNumSystem(),

    token: getToken(),
    FullName: getFullName(),

    userInfo: {},
    isAdmin: hasAdminPermission(),
    isReporter: hasReporterPermission(),
    isModir: hasModirPermission(),
    isModirAdmin: hasModirAdminPermission(),
    isHesabdar: hasHesabdarPermission(),
    isEnduser: hasUserPermission(),
    isAshpaz: hasAshpazPermission(),
    currentRole: getCurrentRole(),
    branches: getBranches(),

    permissions: getPermissions(),
    currentBranch: getCurrentBranch(),
    autoDelivery: getAutoDelivery(),

    menuOptions: [
      {
        icon: "home",
        title: "صفحه اصلی",
        route: "/index",
      },
      {
        icon: "warehouse",
        title: "شعبه ها",
        route: "/branch",
        isAdmin: true,
        color: "#84198C",
      },
      {
        icon: "money-bill",
        title: "گزارش جامع مدارس",
        route: "/reports/payments",
        isReporter: true,
        color: "#84198C",
      },
      {
        icon: "file",
        title: "گزارش لیست های پرداخت",
        route: "/reports/paybacks",
        isReporter: true,
        color: "#84198C",
      },
      {
        icon: "school",
        title: "اطلاعات شعبه",
        route: "/branch/schools",
        isAshpaz: true,
        color: "#84198C",
      },
      {
        icon: "th",
        title: "منوها",
        route: "/branch/menus",
        isHesabdar: true,
        color: "#84198C",
      },
      {
        icon: "check",
        title: "تحویل غذا",
        route: "/branch/orders",
        isAshpaz: true,
        color: "#84198C",
      },
      {
        icon: "users",
        title: "نقش ها",
        route: "/branch/roles",
        isModir: true,
        color: "#84198C",
      },
      {
        icon: "users",
        title: "لیست آزاد",
        route: "/branch/people",
        isModir: true,
        color: "#84198C",
      },

      {
        icon: "building",
        title: "مکان های تحویل",
        route: "/branch/places",
        isModir: true,
        color: "#84198C",
      },

      {
        icon: "utensils",
        title: "غذاها",
        route: "/branch/foods",
        isHesabdar: true,
        color: "#84198C",
      },
      {
        icon: "utensils",
        title: "وعده های غذایی",
        route: "/branch/meals",
        isHesabdar: true,
        color: "#84198C",
      },

      {
        icon: "utensils",
        title: "گزارش سفارشات",
        route: "/branch/ordersReport",
        isAshpaz: true,
        color: "#84198C",
      },
      {
        icon: "users",
        title: "گزارش کاربران",
        route: "/branch/users",
        isHesabdar: true,
        color: "#84198C",
      },
      {
        icon: "utensils",
        title: "جزییات سفارشات",
        route: "/branch/allorders",
        isAshpaz: true,
        color: "#84198C",
      },
      {
        icon: "money-bill",
        title: "حسابداری",
        route: "/branch/payments",
        isHesabdar: true,
        color: "#84198C",
      },
      {
        icon: "file",
        title: "لیست های پرداخت",
        route: "/branch/paybacks",
        isHesabdar: true,
        color: "#84198C",
      },
      {
        icon: "users",
        title: "همه کاربران",
        route: "/branch/allusers",
        isHesabdar: true,
        color: "#84198C",
      },
      {
        icon: "question-circle",
        title: "راهنما",
        route:
          "https://hozehkh.com/res/food_help.mp4",
        color: "#CB6015",
        isAshpaz: true,
      },
      {
        icon: "utensils",
        title: "رزرو غذا",
        route: "/reserve",
        isEnduser: true,
        color: "#84198C",
      },
      {
        icon: "money-bill",
        title: "کیف پول",
        route: "/payments",
        isEnduser: true,
        color: "#84198C",
      },
      {
        icon: "utensils",
        title: " سفارشات",
        route: "/orders",
        isEnduser: true,
        color: "#84198C",
      },
    ],
  },

  mutations: {
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo;
    },

    SET_FULLNAME: (state, FullName) => {
      state.FullName = FullName;
    },
    SET_NUM_SYSTEM: (state, Num_System) => {
      state.Num_System = Num_System;
    },

    SET_AVATAR: (state, ImageUrl) => {
      state.ImageUrl = ImageUrl;
    },

    SET_TOKEN: (state, token) => {
      state.token = token;
      setToken(token);
    },
  },

  actions: {
    GetUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo()
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            const data = response.data.data;

            commit("SET_USERINFO", data);
            commit("SET_FULLNAME", data.name + " " + data.family);
            commit("SET_NUM_SYSTEM", data.numSystem);
            commit("SET_AVATAR", data.imageUrl);

            setSlider(
              data.Name + " " + data.Famil,
              data.Num_System,
              data.ImageUrl
            );

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GetBranchNames({ commit }, url) {
      return new Promise((resolve, reject) => {
        GetBranchNames()
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            const data = response.data.data;
            let tempBranches = getBranches();
            let tempPermissions = getPermissions();
            tempBranches.map((b) => {
              b.BranchName = data[b.BranchID];
            });
            tempPermissions.map((b) => {
              b.BranchName = data[b.BranchID];
            });
            setBranches(
              JSON.stringify(tempBranches),
              JSON.stringify(tempPermissions)
            );

            if (url) window.location = url;
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    LogOut({ commit }) {
      commit("SET_NUM_SYSTEM", "");
      commit("SET_FULLNAME", "");
      commit("SET_AVATAR", "");
      removeToken();
      document.location = process.env.VUE_APP_API_ENDPOINT + "/Home/Logout";
    },

    setSelectedDashboard({ commit, dispatch }, Dashboard) {
      commit("SET_SELECTED_DASHBOARD", Dashboard);
    },
    setInboxCount({ commit }, inbox_count) {
      commit("SET_INBOX_COUNT", inbox_count);
    },
  },
};
